import { render, staticRenderFns } from "./DashboardJournalEntreprises.vue?vue&type=template&id=47b2b59d&scoped=true&"
import script from "./DashboardJournalEntreprises.vue?vue&type=script&lang=js&"
export * from "./DashboardJournalEntreprises.vue?vue&type=script&lang=js&"
import style0 from "./DashboardJournalEntreprises.vue?vue&type=style&index=0&id=47b2b59d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b2b59d",
  null
  
)

export default component.exports